declare const swal: any
declare const $: any

export class SwalService {
  public static async showLoadingModal<T = any>(title: string, asyncMethod: () => Promise<void>): Promise<T> {
    return swal({
      title,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      onOpen: async () => {
        swal.showLoading()
        await asyncMethod()
        swal.hideLoading()
        swal.clickConfirm()
      },
    })
  }

  public static async showModal<T = any>(title: string): Promise<T> {
    return swal({
      title,
    })
  }

  public static showNotification(
    message: string,
    messageType: "warning" | "info" | "danger",
    icon: string = "ti-alert",
  ): void {
    $.notify(
      {
        icon,
        message,
      },
      {
        type: messageType,
        timer: 2000,
        placement: {
          from: "top",
          align: "center",
        },
      },
    )
  }
}
